import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class LinkedPartGroupService extends Service {
	constructor(injector: Injector) {
		super("LinkedPartGroup", injector);
	}
}